// src/blocto-design-token/build/bo/web/borderWidthAlias.js
var borderWidthAliasTokens = {
  "width.s": "boGlobalBorder.width.1",
  "width.m": "boGlobalBorder.width.2",
  "width.l": "boGlobalBorder.width.3"
};

// src/blocto-design-token/build/bo/web/borderWidthGlobal.js
var borderWidthGlobalTokens = {
  "boGlobalBorder": {
    "width": {
      "1": "0.5px",
      "2": "1px",
      "3": "1.5px",
      "4": "2px",
      "5": "2.5px",
      "6": "3px"
    }
  }
};

// src/blocto-design-token/build/bo/web/colorAlias.js
var colorAliasTokens = {
  "background.primary": "boGlobalColor.white",
  "background.secondary": "boGlobalColor.bluegray.50",
  "background.tertiary": "boGlobalColor.iron.50",
  "background.alert": "boGlobalColor.red.50",
  "background.info": "boGlobalColor.bluegray.900A90",
  "background.badge": "boGlobalColor.bluegray.900A60",
  "background.warning": "boGlobalColor.amber.50",
  "background.avatar": "boGlobalColor.iron.200",
  "border.primary": "boGlobalColor.bluegray.400",
  "border.secondary": "boGlobalColor.bluegray.300",
  "border.tertiary": "boGlobalColor.bluegray.200",
  "border.highlight": "boGlobalColor.oceanblue.700",
  "border.alert": "boGlobalColor.red.400",
  "border.inverse": "boGlobalColor.white",
  "font.primary": "boGlobalColor.bluegray.900",
  "font.primary.hovered": "boGlobalColor.bluegray.900A60",
  "font.primary.pressed": "boGlobalColor.bluegray.900A60",
  "font.primary.disabled": "boGlobalColor.bluegray.900A30",
  "font.primary.placeholder": "boGlobalColor.bluegray.900A30",
  "font.secondary": "boGlobalColor.bluegray.600",
  "font.tertiary": "boGlobalColor.bluegray.400",
  "font.highlight": "boGlobalColor.oceanblue.700",
  "font.highlight.pressed": "boGlobalColor.oceanblue.700A60",
  "font.highlight.disabled": "boGlobalColor.oceanblue.700A30",
  "font.highlight.placeholder": "boGlobalColor.oceanblue.700A30",
  "font.inverse": "boGlobalColor.white",
  "font.alert": "boGlobalColor.red.400",
  "icon.primary": "boGlobalColor.bluegray.900",
  "icon.secondary": "boGlobalColor.bluegray.600",
  "icon.tertiary": "boGlobalColor.bluegray.400",
  "icon.disabled": "boGlobalColor.bluegray.300",
  "icon.inverse": "boGlobalColor.white",
  "icon.highlight": "boGlobalColor.oceanblue.700",
  "icon.highlight.secondary": "boGlobalColor.oceanblue.400",
  "icon.text": "boGlobalColor.iron.900",
  "icon.alert": "boGlobalColor.red.400",
  "icon.warning": "boGlobalColor.amber.600",
  "interaction.primary": "boGlobalColor.oceanblue.700",
  "interaction.primary.hovered": "boGlobalColor.oceanblue.700A60",
  "interaction.primary.pressed": "boGlobalColor.oceanblue.700A60",
  "interaction.primary.disabled": "boGlobalColor.oceanblue.700A30",
  "interaction.secondary": "boGlobalColor.iron.50",
  "interaction.secondary.hovered": "boGlobalColor.iron.50A60",
  "interaction.secondary.pressed": "boGlobalColor.iron.50A60",
  "interaction.inverse": "boGlobalColor.white",
  "status.success.light": "boGlobalColor.lime.50",
  "status.success.dark": "boGlobalColor.lime.900",
  "status.error.light": "boGlobalColor.red.50",
  "status.error.dark": "boGlobalColor.red.400",
  "status.neutral.light": "boGlobalColor.iron.50",
  "status.neutral.dark": "boGlobalColor.bluegray.900",
  "status.info.light": "boGlobalColor.bluegray.50",
  "status.info.dark": "boGlobalColor.oceanblue.700",
  "status.warning.light": "boGlobalColor.amber.100",
  "status.warning.dark": "boGlobalColor.amber.600"
};

// src/blocto-design-token/build/bo/web/colorGlobal.js
var colorGlobalTokens = {
  "boGlobalColor": {
    "oceanblue": {
      "50": "#E2F3FF",
      "100": "#BAE0FF",
      "200": "#8BCEFF",
      "300": "#53BAFF",
      "400": "#14AAFF",
      "500": "#009AFF",
      "600": "#008BFF",
      "700": "#0075FF",
      "800": "#1564EC",
      "900": "#2242CD",
      "700A60": "#0075FF99",
      "700A30": "#0075FF4D"
    },
    "deepblue": {
      "50": "#EAECFD",
      "100": "#C9CEF9",
      "200": "#A3AFF6",
      "300": "#7B8FF2",
      "400": "#5A74EF",
      "500": "#365BEA",
      "600": "#3051DE",
      "700": "#0075FF",
      "800": "#183BC6",
      "900": "#0025B4"
    },
    "skyblue": {
      "50": "#E8F4FD",
      "100": "#C6E4FB",
      "200": "#A5D4F9",
      "300": "#83C4F8",
      "400": "#68B6F9",
      "500": "#53AAFB",
      "600": "#4C9BEC",
      "700": "#4489D9",
      "800": "#3C78C8",
      "900": "#2F59AA"
    },
    "aqua": {
      "50": "#E7F9FF",
      "100": "#C1F0FF",
      "200": "#98E6FF",
      "300": "#6FDCFF",
      "400": "#52D3FF",
      "500": "#40CBFF",
      "600": "#3ABBFC",
      "700": "#32A7E7",
      "800": "#2D95D4",
      "900": "#2174B3"
    },
    "cyan": {
      "50": "#E8FDFC",
      "100": "#C5FAF7",
      "200": "#A0F8F5",
      "300": "#80F4F2",
      "400": "#6DF0EF",
      "500": "#64EBEF",
      "600": "#5FD9DC",
      "700": "#58C2C1",
      "800": "#51ADAA",
      "900": "#45877F"
    },
    "lime": {
      "50": "#F2FFF5",
      "100": "#E0FFE7",
      "200": "#C4FDD2",
      "300": "#ADFDBF",
      "400": "#9DFEB3",
      "500": "#8BFBA3",
      "600": "#83EB99",
      "700": "#76D68A",
      "800": "#6CC47E",
      "900": "#5AA168"
    },
    "amber": {
      "50": "#FFF8E0",
      "100": "#FFECB0",
      "200": "#FFE07C",
      "300": "#FFD544",
      "400": "#FFC90A",
      "500": "#FFC100",
      "600": "#FFB200",
      "700": "#FF9F00",
      "800": "#FF8D00",
      "900": "#FF6B00"
    },
    "red": {
      "50": "#FFECEF",
      "100": "#FFCFD5",
      "200": "#F99D9E",
      "300": "#F37678",
      "400": "#FF5555",
      "500": "#FF4239",
      "600": "#F7393A",
      "700": "#E42E33",
      "800": "#D7262C",
      "900": "#C8191F"
    },
    "iron": {
      "50": "#F9F9F9",
      "100": "#E4E8ED",
      "200": "#BAC6D5",
      "300": "#8FA1B8",
      "400": "#657E9C",
      "500": "#436389",
      "600": "#194B79",
      "700": "#114471",
      "800": "#053B66",
      "900": "#00325A",
      "50A60": "#F9F9F999"
    },
    "bluegray": {
      "50": "#F8FBFF",
      "100": "#F3F6FA",
      "200": "#EEF1F5",
      "300": "#E1E4E8",
      "400": "#BFC2C6",
      "500": "#A0A3A7",
      "600": "#777A7D",
      "700": "#636669",
      "800": "#444649",
      "900": "#232528",
      "900A60": "#23252899",
      "900A90": "#232528E6",
      "900A30": "#2325284D"
    },
    "white": "#FFFFFF"
  }
};

// src/blocto-design-token/build/bo/web/dimensionAlias.js
var dimensionAliasTokens = {
  "icon.3xs": "boGlobalDimension.size.6",
  "icon.2xs": "boGlobalDimension.size.7",
  "icon.xs": "boGlobalDimension.size.8",
  "icon.s": "boGlobalDimension.size.10",
  "icon.m": "boGlobalDimension.size.11",
  "icon.l": "boGlobalDimension.size.13",
  "icon.xl": "boGlobalDimension.size.15",
  "icon.2xl": "boGlobalDimension.size.16",
  "icon.3xl": "boGlobalDimension.size.17",
  "radius.m": "boGlobalDimension.size.6",
  "radius.s": "boGlobalDimension.size.3",
  "space.5xs": "boGlobalDimension.size.1",
  "space.4xs": "boGlobalDimension.size.2",
  "space.3xs": "boGlobalDimension.size.3",
  "space.2xs": "boGlobalDimension.size.4",
  "space.xs": "boGlobalDimension.size.5",
  "space.s": "boGlobalDimension.size.6",
  "space.m": "boGlobalDimension.size.8",
  "space.l": "boGlobalDimension.size.10",
  "space.xl": "boGlobalDimension.size.11",
  "space.2xl": "boGlobalDimension.size.12",
  "space.3xl": "boGlobalDimension.size.13",
  "space.4xl": "boGlobalDimension.size.15",
  "space.5xl": "boGlobalDimension.size.18",
  "space.layout.1x": "boGlobalDimension.size.20",
  "space.layout.2x": "boGlobalDimension.size.21"
};

// src/blocto-design-token/build/bo/web/dimensionGlobal.js
var dimensionGlobalTokens = {
  "boGlobalDimension": {
    "size": {
      "1": "0.125rem",
      "2": "0.25rem",
      "3": "0.375rem",
      "4": "0.5rem",
      "5": "0.625rem",
      "6": "0.75rem",
      "7": "0.875rem",
      "8": "1rem",
      "9": "1.125rem",
      "10": "1.25rem",
      "11": "1.5rem",
      "12": "1.75rem",
      "13": "2rem",
      "14": "2.25rem",
      "15": "2.5rem",
      "16": "3rem",
      "17": "3.5rem",
      "18": "4rem",
      "19": "4.5rem",
      "20": "5rem",
      "21": "10rem"
    }
  }
};

// src/blocto-design-token/build/bo/web/fontFamily.js
var fontFamilyTokens = {
  "boFontFamily": {
    "base": "Work Sans",
    "italic": "Work Sans-Italic"
  }
};

// src/blocto-design-token/build/bo/web/fontSizeAlias.js
var fontSizeAliasTokens = {
  "size.heading.0": "boGlobalFont.size.9",
  "size.heading.1": "boGlobalFont.size.8",
  "size.heading.2": "boGlobalFont.size.7",
  "size.heading.3": "boGlobalFont.size.6",
  "size.heading.4": "boGlobalFont.size.5",
  "size.heading.5": "boGlobalFont.size.4",
  "size.subheading.1": "boGlobalFont.size.5",
  "size.subheading.2": "boGlobalFont.size.4",
  "size.subheading.3": "boGlobalFont.size.3",
  "size.body.1": "boGlobalFont.size.5",
  "size.body.2": "boGlobalFont.size.4",
  "size.body.3": "boGlobalFont.size.3",
  "size.help.1": "boGlobalFont.size.2",
  "size.help.2": "boGlobalFont.size.1"
};

// src/blocto-design-token/build/bo/web/fontSizeGlobal.js
var fontSizeGlobalTokens = {
  "boGlobalFont": {
    "size": {
      "1": "0.625rem",
      "2": "0.75rem",
      "3": "0.875rem",
      "4": "1rem",
      "5": "1.25rem",
      "6": "1.5rem",
      "7": "1.75rem",
      "8": "2.25rem",
      "9": "2.75rem"
    }
  }
};

// src/blocto-design-token/build/bo/web/fontWeightAlias.js
var fontWeightAliasTokens = {
  "weight.l": "boGlobalFont.weight.semibold",
  "weight.m": "boGlobalFont.weight.medium",
  "weight.s": "boGlobalFont.weight.regular"
};

// src/blocto-design-token/build/bo/web/fontWeightGlobal.js
var fontWeightGlobalTokens = {
  "boGlobalFont": {
    "weight": {
      "regular": "400",
      "medium": "500",
      "semibold": "600"
    }
  }
};

// src/blocto-design-token/build/bo/web/lineHeightAlias.js
var lineHeightAliasTokens = {
  "line.height.heading.0": "boGlobalFont.lineHeight.9",
  "line.height.heading.1": "boGlobalFont.lineHeight.8",
  "line.height.heading.2": "boGlobalFont.lineHeight.7",
  "line.height.heading.3": "boGlobalFont.lineHeight.6",
  "line.height.heading.4": "boGlobalFont.lineHeight.4",
  "line.height.subheading.1": "boGlobalFont.lineHeight.5",
  "line.height.subheading.2": "boGlobalFont.lineHeight.4",
  "line.height.subheading.3": "boGlobalFont.lineHeight.3",
  "line.height.body.1": "boGlobalFont.lineHeight.5",
  "line.height.body.2": "boGlobalFont.lineHeight.4",
  "line.height.body.3": "boGlobalFont.lineHeight.3",
  "line.height.help.1": "boGlobalFont.lineHeight.2",
  "line.height.help.2": "boGlobalFont.lineHeight.1"
};

// src/blocto-design-token/build/bo/web/lineHeightGlobal.js
var lineHeightGlobalTokens = {
  "boGlobalFont": {
    "lineHeight": {
      "1": "0.9375rem",
      "2": "1.125rem",
      "3": "1.25rem",
      "4": "1.375rem",
      "5": "1.75rem",
      "6": "1.875rem",
      "7": "2.1875rem",
      "8": "2.8125rem",
      "9": "3.4375rem"
    }
  }
};

// src/index.ts
var boTheme = {
  config: {
    cssVarPrefix: "c"
  },
  colors: colorGlobalTokens,
  space: dimensionGlobalTokens,
  fonts: fontFamilyTokens,
  fontSizes: fontSizeGlobalTokens,
  fontWeights: fontWeightGlobalTokens,
  lineHeights: lineHeightGlobalTokens,
  borderWidths: borderWidthGlobalTokens,
  semanticTokens: {
    colors: colorAliasTokens,
    space: dimensionAliasTokens,
    fonts: {
      body: "'Work Sans', sans-serif",
      heading: "'Work Sans', sans-serif"
    },
    fontSizes: fontSizeAliasTokens,
    fontWeights: fontWeightAliasTokens,
    lineHeights: lineHeightAliasTokens,
    borderWidths: borderWidthAliasTokens
  }
};
var src_default = boTheme;
export {
  boTheme,
  src_default as default
};
